const STREAM_PROGRESS_PREFIX = '[progress]';

/** Separates `[progress] ...` stream lines from real model reasoning. */
export function splitProgressFromReasoning(reasoning: string | null): {
  progressMessages: string[];
  reasoning: string | null;
} {
  if (!reasoning) {
    return { progressMessages: [], reasoning: null };
  }

  const progressMessages: string[] = [];
  const reasoningLines: string[] = [];

  for (const line of reasoning.split(/\r?\n/)) {
    const trimmed = line.trim();
    if (trimmed.startsWith(STREAM_PROGRESS_PREFIX)) {
      const progress = trimmed.slice(STREAM_PROGRESS_PREFIX.length).trim();
      if (progress) {
        progressMessages.push(progress);
      }
      continue;
    }

    reasoningLines.push(line);
  }

  const cleanedReasoning = reasoningLines.join('\n').trim();
  return {
    progressMessages,
    reasoning: cleanedReasoning || null,
  };
}
